"use strict";
/**
 * @module Services.TopicNotifications
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var conversation_id_serialiser_1 = require("./../../conversation/conversation-id-serialiser");
var Codec = require("./../../io/codec");
var BEES = require("./../../serialisers/byte-encoded-enum-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
var TopicSpecificationSerialiser = require("./../../topics/details/topic-specification-serialiser");
var topic_notifications_1 = require("../../../features/topic-notifications");
var topic_notification_event_1 = require("./topic-notification-event");
/**
 * Serialiser for {@link TopicNotificationEvent}
 */
var TopicNotificationEventSerialiserClass = /** @class */ (function (_super) {
    __extends(TopicNotificationEventSerialiserClass, _super);
    function TopicNotificationEventSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link TopicNotificationEvent} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link TopicNotificationEvent} that was read
     */
    TopicNotificationEventSerialiserClass.prototype.read = function (bis) {
        var cid = conversation_id_serialiser_1.CIDSerialiser.read(bis);
        var topicPath = Codec.readString(bis);
        var type = BEES.read(bis, topic_notifications_1.TopicNotificationType);
        var specification = TopicSpecificationSerialiser.read(bis);
        return new topic_notification_event_1.TopicNotificationEvent(cid, topicPath, type, specification);
    };
    return TopicNotificationEventSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.TopicNotificationEventSerialiserClass = TopicNotificationEventSerialiserClass;
/**
 * The {@link TopicNotificationEventSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.TopicNotificationEventSerialiser = new TopicNotificationEventSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-notifications/topic-notification-event-serialiser.js
// module id = 2010
// module chunks = 1